import { render, staticRenderFns } from "./HistoryCoach.vue?vue&type=template&id=07a74d98"
import script from "./HistoryCoach.vue?vue&type=script&lang=js"
export * from "./HistoryCoach.vue?vue&type=script&lang=js"
import style0 from "./HistoryCoach.vue?vue&type=style&index=0&id=07a74d98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports